import React from 'react';
import { AnimatedSection } from './AnimatedSection';
interface PageBannerProps {
  title: string;
  subtitle?: string;
  image: string;
  credit?: string;
}
export function PageBanner({
  title,
  subtitle,
  image,
  credit = '© Firetree Fund'
}: PageBannerProps) {
  return <div className="relative w-full overflow-hidden" style={{
    height: '340px'
  }} data-id="element-167">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url("${image}")`
    }} data-id="element-168" />
      <div className="absolute inset-0 bg-brand-charcoal/60" data-id="element-169" />
      <div className="absolute inset-0 bg-gradient-to-t from-brand-charcoal/40 to-transparent" data-id="element-170" />
      <div className="relative h-full flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-171">
        <AnimatedSection data-id="element-172">
          <h1 className="text-[32px] md:text-[44px] lg:text-[56px] font-serif text-white leading-tight" data-id="element-173">
            {title}
          </h1>
          {subtitle && <p className="text-lg md:text-xl text-white/75 mt-4 max-w-2xl mx-auto" data-id="element-174">
              {subtitle}
            </p>}
        </AnimatedSection>
      </div>

      {credit && <div className="absolute bottom-0 right-0 p-2 pr-3 pointer-events-none" data-id="element-175">
          <span className="text-[10px] text-white font-medium opacity-80 drop-shadow-sm" data-id="element-176">
            {credit}
          </span>
        </div>}
    </div>;
}